import React, { Component } from 'react'
import { find, get, map } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { finishLoadPrintTemplate, loadPrintTemplate } from '../actions'
import { Table, Typography } from 'antd'
import { getVar } from '../../../../system/support/helpers'

class PrintPackageHasProductIssue extends Component {
    constructor(props) {
        super()
        props.loadPrintTemplate()
    }

    componentDidMount() {
        const { finishLoadPrintTemplate, onDidMount } = this.props
        finishLoadPrintTemplate()
        onDidMount()
    }

    render() {
        const { packageData, packageItems, packageDamagedReasons } = this.props
        console.log('this.props', this.props)
        return (
            <table className="issue-table">
                <thead>
                    <tr>
                        <th>Product Code</th>
                        <th>Reason</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {packageItems.map((item, index) => {
                        const issues = getVar(item, 'package_item_issues', [])
                        if (!issues.length) {
                            return null
                        }

                        return issues.map((issue, issueIndex) => {
                            const issueName = getVar(find(this.props.packageDamagedReasons, ['code', issue.issue_type]), 'name', issue.issue_type)

                            return (
                                <tr
                                    className="a-text--center"
                                    key={`${index}-${issueIndex}`}>
                                    {issueIndex === 0 && <td rowSpan={issues.length}>{getVar(item, 'package_item.code_item', '---')}</td>}
                                    <td>{issueName}</td>
                                    <td>{getVar(issue, 'description', '---')}</td>
                                </tr>
                            )
                        })
                    })}
                </tbody>
            </table>
        )
    }
}

PrintPackageHasProductIssue.defaultProps = {
    onDidMount: () => {},
}

PrintPackageHasProductIssue.propTypes = {
    onDidMount: PropTypes.func,
}

export default connect(undefined, {
    finishLoadPrintTemplate,
    loadPrintTemplate,
})(PrintPackageHasProductIssue)
